import React, { useContext } from 'react';
import { TabsProps } from 'antd';

import DateRangeContainer from '@totem/components/common/dateRangePicker/dateRangeContainer';
import { Profile } from '@totem/components/settings/sections/profile/Profile';
import BillingContainer from '@totem/components/ticketing/billing/billingContainer';
import UnbilledPane from '@totem/components/ticketing/billing/unbilledPane';
import EmployeeUtilizationContainer from '@totem/components/ticketing/employeeUtilization/employeeUtilizationContainer';
import EmployeeUtilizationFilters from '@totem/components/ticketing/employeeUtilization/employeeUtilizationFilters';
import EmployeeUtilizationTable from '@totem/components/ticketing/employeeUtilization/employeeUtilizationTable';
import TimeEntryReport from '@totem/components/ticketing/employeeUtilization/timeEntryReport';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const UserProfilePage = () => {
  const { userProfile } = useContext(UserProfileContext);

  const getTabItems = () => {
    const tabItems: TabsProps['items'] = [
      {
        key: 'profile',
        label: 'Profile',
        children: <Profile />,
      },
    ];

    if (permissions.internal.hasPermissions(userProfile)) {
      tabItems.push({
        key: 'billableHours',
        label: 'Billable Hours',
        children: (
          <DateRangeContainer defaultTimeFrame={'week'} allowClear>
            <BillingContainer
              billingParams={{
                resourceEmails: [userProfile.email],
                ticketIds: [],
              }}
            >
              <UnbilledPane />
            </BillingContainer>
          </DateRangeContainer>
        ),
      });

      tabItems.push({
        key: 'utilization',
        label: 'Utilization',
        children: (
          <EmployeeUtilizationContainer employees={[userProfile.email]}>
            <EmployeeUtilizationFilters /> <EmployeeUtilizationTable />
            <br />
            <br />
            <TimeEntryReport />
          </EmployeeUtilizationContainer>
        ),
      });
    }

    return tabItems;
  };

  return (
    <ContentLayout>
      <IBCard title={userProfile.email} isCovered>
        <IBTabs defaultActiveKey="profile" items={getTabItems()} />
      </IBCard>
    </ContentLayout>
  );
};

export default UserProfilePage;
